(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (window.matchMedia('(min-width: 750px)').matches) {
    const plp = document.querySelector('.evry-plp');
    if (plp && plp.dataset.plpDesktopGalleryBound !== 'true') {
      plp.dataset.plpDesktopGalleryBound = 'true';

      const settleGallery = (gallery, ms) => {
        gallery.setAttribute('data-plp-settling', '1');
        window.setTimeout(() => {
          gallery.removeAttribute('data-plp-settling');
        }, ms);
      };

      const grid = plp.querySelector('[ref="grid"]');
      if (grid) {
        new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (!(node instanceof HTMLElement)) return;
              node.querySelectorAll('.card-gallery').forEach((gallery) => {
                settleGallery(gallery, 800);
              });
            });
          });
        }).observe(grid, { childList: true });
      }
    }

    if (document.body.dataset.plpDesktopGalleryBound !== 'true') {
      document.body.dataset.plpDesktopGalleryBound = 'true';

      document.addEventListener(
        'pointerdown',
        (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;

          const swatchBtn = target.closest('[data-plp-swatch]');
          if (!(swatchBtn instanceof HTMLElement) || !swatchBtn.closest('.evry-plp')) return;

          const item = swatchBtn.closest('.product-grid__item') || swatchBtn.closest('product-card');
          const gallery = item?.querySelector('.card-gallery');
          if (!gallery) return;

          gallery.setAttribute('data-plp-variant-locked', '1');
          window.setTimeout(() => {
            gallery.removeAttribute('data-plp-variant-locked');
          }, 2000);
        },
        true
      );
    }
  }

  } catch(e) { console.error(e); }
})();
})();
